/**
 * Triggers a browser download for a Blob object.
 *
 * @param blob The Blob object to be downloaded (e.g., new Blob(['content'], { type: 'text/plain' })).
 * @param filename The desired name for the downloaded file.
 */
export function downloadFile(blob: Blob, filename: string): void {
    if (!(blob instanceof Blob)) {
        return;
    }

    // Legacy support for Internet Explorer 10+
    const legacyNavigator = navigator as any;
    if (legacyNavigator.msSaveBlob) {
        legacyNavigator.msSaveBlob(blob, filename);
        return;
    }

    const safeName = (filename ?? '').trim() || 'download';
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    try {
        link.href = url;
        link.download = safeName;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();

        // Give the browser plenty of time to start the download before revoking.
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
}
